module.exports = __webpack_public_path__ + "media/images/favicon/favicon-32x32-4f82258d60610bccde287e312a86235d.png";